import { withInstall } from '@bigin/utils'

import ImageViewer from './src/image-viewer.vue'

export const BImageViewer = withInstall(ImageViewer)
export default BImageViewer

export * from './src/image-viewer'
